import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Helper to get auth headers
const getAuthHeaders = () => {
    const token = localStorage.getItem('adminToken');
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
};

/**
 * Get all reports with optional filtering
 */
export const getAllReports = async (filters = {}) => {
    try {
        const params = new URLSearchParams();
        
        if (filters.status && filters.status !== 'all') {
            params.append('status', filters.status);
        }
        if (filters.limit) {
            params.append('limit', filters.limit);
        }
        if (filters.skip) {
            params.append('skip', filters.skip);
        }

        const response = await axios.get(
            `${BACKEND_URL}/api/admin/reports${params.toString() ? `?${params.toString()}` : ''}`,
            { headers: getAuthHeaders() }
        );

        return {
            success: true,
            data: response.data.data
        };
    } catch (error) {
        console.error('Get reports error:', error);
        return {
            success: false,
            message: error.response?.data?.detail || 'Failed to fetch reports'
        };
    }
};

/**
 * Get a single report by ID
 */
export const getReport = async (reportId) => {
    try {
        const response = await axios.get(
            `${BACKEND_URL}/api/admin/reports/${reportId}`,
            { headers: getAuthHeaders() }
        );

        return {
            success: true,
            data: response.data.data
        };
    } catch (error) {
        console.error('Get report error:', error);
        return {
            success: false,
            message: error.response?.data?.detail || 'Failed to fetch report'
        };
    }
};

/**
 * Update report status and add admin notes
 */
export const updateReport = async (reportId, updateData) => {
    try {
        const response = await axios.put(
            `${BACKEND_URL}/api/admin/reports/${reportId}`,
            updateData,
            { headers: getAuthHeaders() }
        );

        return {
            success: true,
            data: response.data.data,
            message: response.data.message
        };
    } catch (error) {
        console.error('Update report error:', error);
        return {
            success: false,
            message: error.response?.data?.detail || 'Failed to update report'
        };
    }
};

/**
 * Get report statistics
 */
export const getReportsStatistics = async () => {
    try {
        const response = await axios.get(
            `${BACKEND_URL}/api/admin/reports/statistics/summary`,
            { headers: getAuthHeaders() }
        );

        return {
            success: true,
            data: response.data.data
        };
    } catch (error) {
        console.error('Get report statistics error:', error);
        return {
            success: false,
            message: error.response?.data?.detail || 'Failed to fetch statistics'
        };
    }
};
